export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative overflow-hidden rounded-2xl border border-background-200/60 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40">
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary-100/30 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-100/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative flex flex-col md:flex-row items-center gap-8 p-7 md:p-10">
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
                APP体验
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-6">
                99漫画移动端适配完美，无论是在手机浏览器还是平板设备上，
                都能享受流畅的<strong className="text-foreground-900">下拉式阅读</strong>体验。
                无需下载安装，打开浏览器即可畅读韩漫、日漫、国漫全集大全。
                支持收藏同步、追更提醒，随时随地沉浸在漫画世界中。
              </p>

              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-apple-line"></i>
                  iOS 网页版
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 text-background-50 rounded-full text-sm font-medium hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-android-line"></i>
                  Android 网页版
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-2.5 bg-background-100 text-foreground-600 rounded-full text-sm font-medium hover:bg-background-200 transition-colors border border-background-200 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-computer-line"></i>
                  电脑网页版
                </a>
              </div>
            </div>

            <div className="flex-shrink-0 w-44 md:w-52">
              <div className="aspect-[9/16] rounded-2xl border-2 border-background-200 bg-background-100 overflow-hidden">
                <div className="h-full flex flex-col">
                  <div className="h-2 bg-background-300/40 mx-3 mt-2 rounded"></div>
                  <div className="flex-1 flex flex-col items-center justify-center gap-2 p-3">
                    <div className="w-10 h-10 rounded-xl bg-primary-100 flex items-center justify-center">
                      <i className="ri-book-open-line text-primary-500 text-lg"></i>
                    </div>
                    <span className="text-xs font-medium text-foreground-700">99漫画</span>
                    <span className="text-[10px] text-foreground-400">下拉式阅读 · 追更收藏</span>
                    <div className="w-full h-1.5 bg-background-200 rounded-full mt-1"></div>
                    <div className="w-3/4 h-1 bg-background-200 rounded-full"></div>
                    <div className="w-1/2 h-1 bg-background-200 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}